const session_expired = {
    title: 'Истекло время сеанса',
    subtitle: 'Ваш сеанс, возможно, истек и вы были отключены. Нажмите кнопку ниже, чтобы снова войти в консоль администратора.',
    button: 'Войти снова',
};
export default Object.freeze(session_expired);
